<template>
  <div class="paso-confirmar">

    <!-- Stat grid -->
    <div class="stat-grid">

      <div class="stat-card">
        <div class="stat-icon-wrap stat-icon-wrap--blue">
          <v-icon size="20" color="white">mdi-truck-outline</v-icon>
        </div>
        <div class="stat-body">
          <div class="stat-label">Proveedor</div>
          <div class="stat-value">{{ proveedorNombre || '—' }}</div>
        </div>
      </div>

<div class="stat-card">
        <div class="stat-icon-wrap stat-icon-wrap--indigo">
          <v-icon size="20" color="white">{{ modo === 'SIMPLE' ? 'mdi-table-row' : 'mdi-table-multiple' }}</v-icon>
        </div>
        <div class="stat-body">
          <div class="stat-label">Modo</div>
          <div class="stat-value">{{ modo === 'SIMPLE' ? 'Simple' : 'Estructurado' }}</div>
        </div>
      </div>

      <div class="stat-card stat-card--highlight">
        <div class="stat-icon-wrap stat-icon-wrap--green">
          <v-icon size="20" color="white">mdi-package-variant-closed</v-icon>
        </div>
        <div class="stat-body">
          <div class="stat-label">Productos a importar</div>
          <div class="stat-value stat-value--big">{{ productosParaEnviar.length }}</div>
        </div>
      </div>

    </div>

    <!-- Aviso -->
    <div class="confirm-notice">
      <v-icon small color="#E65100" class="mr-2 flex-shrink-0">mdi-alert-outline</v-icon>
      <span>
        Se van a crear <strong>{{ productosParaEnviar.length }} producto(s)</strong> en el sistema.
        Esta accion no se puede deshacer. Revisa los datos antes de confirmar.
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: "PasoConfirmar",
  props: {
    productosParaEnviar: { type: Array, default: () => [] },
    proveedorNombre: { type: String, default: "" },
    modo: { type: String, required: true },
  },
};
</script>

<style scoped>
.paso-confirmar {
  max-width: 700px;
}

/* Stat grid */
.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #E8EAED;
  border-radius: 10px;
  background: #FAFAFA;
}
.stat-card--highlight {
  background: #F1F8E9;
  border-color: #DCEDC8;
}
.stat-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-icon-wrap--blue   { background: linear-gradient(135deg, #1976D2, #1565C0); }
.stat-icon-wrap--teal   { background: linear-gradient(135deg, #00897B, #00695C); }
.stat-icon-wrap--indigo { background: linear-gradient(135deg, #3949AB, #283593); }
.stat-icon-wrap--green  { background: linear-gradient(135deg, #43A047, #2E7D32); }
.stat-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #757575;
  margin-bottom: 3px;
}
.stat-value {
  font-size: 14px;
  font-weight: 600;
  color: #202124;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stat-value--big {
  font-size: 22px;
  color: #2E7D32;
}

/* Confirm notice */
.confirm-notice {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: #FFF8F0;
  border: 1px solid #FFE0B2;
  border-radius: 8px;
  font-size: 13px;
  color: #E65100;
  line-height: 1.5;
}
</style>
